/*
 * Permedio – GCLID-Restore (lnid → _gcl_aw)
 * Portiert vom alten Theme "Permedio_Genetik" auf Symmetry (Brandpiloten, Okt. 2026)
 * Änderung: läuft auch bei bereits vorhandener Marketing-Einwilligung, nicht nur beim Consent-Event.
 */
(function () {
  var done = false;

  function cp() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function tryRun() {
    if (done || !cp()) return;
    try { if (!cp().marketingAllowed()) return; } catch (e) { return; }
    done = true;
    dwInitGclidRestore();
  }

  document.addEventListener("visitorConsentCollected", tryRun);

  function boot() {
    if (cp()) return tryRun();
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
        if (!err) tryRun();
      });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  function dwInitGclidRestore() {
    var COOKIE_NAME = "_gcl_aw";
    var COOKIE_NAME_P = "GCL_AW_P";
    var CLICK_PARAM = "lnid";
    var MAX_AGE = 90 * 24 * 60 * 60;
    var url = window.location.href;
    var isHttps = url.indexOf("https://") === 0;

    function hasParam(name) {
      var q = url.indexOf("?");
      if (q === -1) return false;
      return ("&" + url.substring(q + 1)).indexOf("&" + name + "=") !== -1;
    }

    function getParamRaw(name) {
      var q = url.indexOf("?");
      if (q === -1) return null;
      var parts = url.substring(q + 1).split("&");
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].split("=");
        if (kv[0] === name) return kv.length > 1 ? kv[1] : "";
      }
      return null;
    }

    function buildSeedTs() {
      return "GCL." + (((Date.now() + 500) / 1000) | 0);
    }

    function getCookieValue(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].replace(/^\s+/, "");
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
      }
      return null;
    }

    function setCookie(name, value) {
      var s = name + "=" + value + "; path=/; max-age=" + MAX_AGE + "; samesite=Lax";
      if (isHttps) s += "; secure";
      var parts = window.location.hostname.split(".");
      if (parts.length >= 2) s += "; domain=." + parts.slice(-2).join(".");
      document.cookie = s;
    }

    function writeCookies(value) {
      setCookie(COOKIE_NAME, value);
      setCookie(COOKIE_NAME_P, value);
    }

    try {
      if (hasParam("gclid")) return;
      var lnidRaw = getParamRaw(CLICK_PARAM);
      if (!lnidRaw) return;
      var existing = getCookieValue(COOKIE_NAME) || "";
      if (!existing) {
        writeCookies(buildSeedTs() + "." + lnidRaw);
        return;
      }
      var firstDot = existing.indexOf(".");
      var secondDot = firstDot === -1 ? -1 : existing.indexOf(".", firstDot + 1);
      if (secondDot === -1) writeCookies(existing + "." + lnidRaw);
    } catch (e) {}
  }
})();
